<template>
  <div class="mt-3">
    <TopSection :title="$t('distributions') | capitalize" />

    <!-- TABLE -->
    <v-server-table
      ref="distributions"
      url="distributions/"
      :columns="columns"
      :options="options"
    >
      <template v-slot:name="{ row }">
        {{ getFileName(row.fund_file.path) }}
      </template>

      <template v-slot:status="{ row }">
        <span>{{ row.status | capitalize }}</span>
      </template>

      <!-- UPLOAD DATE COLUMN -->
      <template v-slot:time_period="{ row }">
        <div class="d-flex flex-column text-nowrap">
          <div v-if="row.start_date" class="d-flex align-items-end">
            <span class="table-sub-class pr-2">{{ $t("from") }}</span>
            <div class="table-main-class">
              {{ row.start_date | transformDate("MMMM Do YYYY") }}
            </div>
          </div>
          <div v-if="row.end_date" class="d-flex align-items-end">
            <span class="table-sub-class pr-2">{{ $t("to") }}</span>
            <div class="table-main-class">
              {{ row.end_date | transformDate("MMMM Do YYYY") }}
            </div>
          </div>
        </div>
      </template>

      <!-- ACTIONS COLUMN -->
      <template v-slot:actions="{ row }">
        <div class="d-flex align-items-center">
          <div
            v-b-tooltip.hover
            class="table-sub-class text-center medium clickable"
            :title="$t('download')"
            @click="getDistributionFile(row)"
          >
            <i class="far fa-file-download mr-2" />
          </div>
        </div>
      </template>
    </v-server-table>

    <!-- The target of the link is the iframe, given by its name -->
    <div style="display:none;">
      <iframe
        v-for="link in downloadLinks"
        :key="link"
        :name="link"
      >
        <a :target="link" :href="link" :id="link" download>{{ link }}</a>
      </iframe>
    </div>
  </div>
</template>


<script>
import {
  doRequest,
  responsePaginatedAdapter
} from "@/assets/libs/utils"
import { api } from "@/main"
import { capitalize } from "lodash"

export default {
  name: "DistrbutionPageMembers",

  data () {
    return {
      downloadLinks: [],
      columns: [
        "name",
        "status",
        "time_period",
        "actions"
      ],
      options: {
        sortable: [],
        headings: {
          name: capitalize(this.$t("name")),
          time_period: capitalize(this.$t("time_period")),
          status: capitalize(this.$t("status")),
          actions: ""
        },
        requestFunction (params) {
          return doRequest(this.url, params)
        },
        responseAdapter: resp => {
          return responsePaginatedAdapter(resp)
        }
      }
    }
  },
  methods: {
    getFileName (str) {
      return str.split("/").pop()
    },
    parseDate (val) {
      const { moment } = this.$options.filters
      return !val ? "" : moment(val).format("YYYY-MM-DD")
    },
    showErrors (errors) {
      errors.forEach(msg => { this.$toasted.global.toast(msg) })
    },
    clickOnDownLoadLink (downloadLink) {
      this.downloadLinks = [downloadLink]
      this.$nextTick(() => {
        const link = document.getElementById(downloadLink)
        link.click()
      })
    },
    getDistributionFile ({ id }) {
      api
        .get(`distributions/${id}/download/`)
        .then(res => {
          const downloadLink = res.data
          try {
            this.clickOnDownLoadLink(downloadLink)
          } catch (error) {
            this.$toasted.global.toast(error)
          }
        })
        .catch(err => {
          if (err.response && err.response.data) {
            this.showErrors(err.response.data)
          } else {
            this.$toasted.global.toast(err)
          }
        })
    },
  },
}
</script>
